<template>
  <div class="container">
    <div class="jumbotron powerSlide">
      <!--<h1 class="display-2">POWER</h1>-->
      <p class="text-secondary text-left">
        Get your Transaction record in CSV format
        <br />insert In the Date range
        <a href="#dateForm">below</a>
      </p>
    </div>

    <WalletForm />
  </div>
</template>

<script>
import WalletForm from '../components/WalletForm.vue'
export default {
  components: {
    WalletForm
  },
  mounted() {}
}
</script>
